import InputModal from './InputModal';

export default InputModal;